import { styled } from "@mui/material";

export const StyledTalent = {
  Root: styled("section")(({ theme }) => ({
    position: "relative",
    paddingBlock: "clamp(72px, 10vw, 128px)",
    color: "#fff",
    background:
      "linear-gradient(160deg, #030B1C, #0A2247 55%, #0E2C5C)",
    overflow: "hidden",
  })),

  Bg: styled("div")({ position: "absolute", inset: 0, pointerEvents: "none" }),

  Blob: styled("span", {
    shouldForwardProp: (prop) => prop !== "variant",
  })(({ variant }) => ({
    position: "absolute",
    borderRadius: "50%",
    filter: "blur(90px)",
    opacity: 0.4,
    ...(variant === 1
      ? {
          width: 460,
          height: 460,
          top: -120,
          left: -80,
          background: "radial-gradient(circle, #2E6FD6, transparent 65%)",
        }
      : {
          width: 420,
          height: 420,
          bottom: -140,
          right: -80,
          background: "radial-gradient(circle, #4BA3E0, transparent 65%)",
        }),
  })),

  Inner: styled("div")({
    position: "relative",
    display: "grid",
    gridTemplateColumns: "1fr 1.05fr",
    gap: "clamp(36px, 5vw, 70px)",
    alignItems: "center",
    "@media (max-width: 960px)": { gridTemplateColumns: "1fr" },
  }),

  Head: styled("div")({}),

  Badge: styled("div")(({ theme }) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 10,
    marginTop: 28,
    padding: "11px 20px",
    borderRadius: theme.custom.radius.full,
    fontFamily: theme.custom.fonts.display,
    fontWeight: 600,
    fontSize: "0.92rem",
    color: "#fff",
    background: "rgba(255,255,255,0.08)",
    border: "1px solid rgba(255,255,255,0.16)",
    "& svg": { color: "#ffd166", fontSize: "1.2rem" },
  })),

  CtaWrap: styled("div")({
    marginTop: 28,
    marginLeft: 16,
    display: "inline-flex",
    "@media (max-width: 480px)": { marginLeft: 0 },
  }),

  Grid: styled("div")({
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 18,
    "@media (max-width: 480px)": { gridTemplateColumns: "1fr" },
  }),

  Card: styled("div")(({ theme }) => ({
    padding: "28px 24px",
    borderRadius: theme.custom.radius.lg,
    background: "rgba(255,255,255,0.05)",
    border: "1px solid rgba(255,255,255,0.1)",
    backdropFilter: "blur(6px)",
    transition: "transform 0.3s ease, background 0.3s ease, border-color 0.3s ease",
    "&:hover": {
      transform: "translateY(-6px)",
      background: "rgba(255,255,255,0.09)",
      borderColor: "rgba(75,163,224,0.35)",
    },
    "& .talent-icon": {
      width: 50,
      height: 50,
      display: "grid",
      placeItems: "center",
      borderRadius: 14,
      color: theme.custom.colors.navy900,
      background: "linear-gradient(135deg, #8AC2EC, #2E6FD6)",
      marginBottom: 18,
      "& svg": { fontSize: "1.5rem" },
    },
    "& h4": {
      color: "#fff",
      fontFamily: theme.custom.fonts.display,
      fontWeight: 700,
      fontSize: "1.15rem",
    },
    "& p": { marginTop: 10, color: "rgba(255,255,255,0.68)", fontSize: "0.92rem" },
  })),
};
